import { FORUM_APP_ID } from '@wix/communities-forum-universal/dist/src/constants/appsConfig.prod';

export const getCurrentInstance = wixCodeApi =>
  wixCodeApi.user.currentUser.instance || wixCodeApi.site.getAppToken(FORUM_APP_ID);
